// utils/fetchAttributionByChain.ts
import { api } from 'src/api';
import { Attribution, ScriptType } from 'src/interfaces';
import { TBlockchain } from 'src/types';
import { isEVMChain } from 'src/utils/crypto';

export async function fetchAttributionByChain(
  chain: TBlockchain,
  addresses: string[],
): Promise<Record<string, Attribution>> {
  if (isEVMChain(chain)) {
    const evmData = await api.blockchain.evm.getEVMAttributions(addresses);
    return Object.fromEntries(
      Object.entries(evmData).map(([addr, data]) => [
        addr,
        {
          _id: addr,
          id: data.id,
          address_type: 'P2PKH' as ScriptType, // Need to clean this up, EVM chains do not support address_type currently
          balance: 0, // EVM balance will be fetched separately - need to clean this up
          cluster_id: addr,
          entity: data.entity,
          display_name: data.display_name,
          entity_type: data.entity_type,
          beneficial_owner: data.beneficial_owner,
          custodian: data.custodian,
        },
      ]),
    );
  }
  return api.blockchain.getBitcoinAttributions(addresses);
}
